import { closeSharingDialog, openSharingDialog } from '../actions/internalActions';
import getStore from '../store/store';
import { mutator } from 'satcheljs';

mutator(openSharingDialog, () => {
    getStore().viewState.isOpen = true;
});

mutator(closeSharingDialog, () => {
    getStore().viewState.isOpen = false;
});
